/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';


export const getCodeBlocks = (feature: BaseNode): CodeBlock[] => {
    const blocks: CodeBlock[] = [];
    const project: ProjectConfiguration = feature.project;
    const featureId = feature.getID();
    const SERIAL_PORT_FEATURE_ID = feature.getSettingValue('SERIAL_PORT');
    const serialPortFeature = project.getFeature(SERIAL_PORT_FEATURE_ID);
    if (!SERIAL_PORT_FEATURE_ID || !serialPortFeature) {
        return [];
    }
    const SERIAL_PORT = `SER_${serialPortFeature.getSettingValue('NAME')}`;

    const links = project.getNodeLinks(feature, 'data_send');
    if (links.length > 0 && SERIAL_PORT !== '') {
        for (let i = 0; i < links.length; i++) {
            const link = links[i];
            const source: BaseNode = project.getFeature(link.getSettingValue('SOURCE_FEATURE')) as BaseNode;
            const sourceParams = source.getPort(link.getSettingValue('SOURCE_PORT'))?.params;
            const DATA = feature.project.parseCodeExpression(feature.getSettingValue('DATA'), sourceParams, TibboDataType.STRING);

            blocks.push({
                location: link.getSourceId(),
                blockType: BlockType.CODE,
                id: `${featureId}_send_data`,
                template: `
simulator.updateContext("${SERIAL_PORT_FEATURE_ID}", {
    ...simulator.context.${SERIAL_PORT_FEATURE_ID},
    buffer: ${DATA}.toString(),
    timestamp: Date.now(),
    type: "send",
})

if (simulator.context.${SERIAL_PORT_FEATURE_ID}.routedTo) {
    onSerDataArrival(simulator.context.${SERIAL_PORT_FEATURE_ID}.routedTo, ${DATA}.toString());
}
                `,
            });
        }
    }
    return blocks;
};
